module.exports = __webpack_public_path__ + "static/img/optima-settings.a3a5e12.svg";